






















import { computed, defineComponent, PropType } from '@vue/composition-api';
import { VueConstructor } from 'vue';
import { DigestMonthlyTiming } from '../model';
import {
	determineScheduleType,
	DigestScheduleType,
	getAllFlattenedDays,
	getFirstWeekWithDays,
} from '../util/scheduling';
import {
	WEEKLY_LABEL_STRINGS,
	MONTHLY_LABEL_STRINGS,
} from '../util/i18n';

export default defineComponent({
	props: {
		tag: {
			type: [String, Object] as PropType<null | string | VueConstructor>,
			required: true,
		},
		timingMonthly: {
			type: Object as PropType<DigestMonthlyTiming>,
			required: true,
		},
		timingPeriodic: {
			type: Number,
			default: -1,
		},
	},
	setup(props) {
		const scheduleType = computed(() => determineScheduleType(props.timingMonthly, props.timingPeriodic));
		const getWeeklyLabel = () => {
			const day = getAllFlattenedDays(props.timingMonthly)[0];
			if (!day) {
				return '';
			}
			return WEEKLY_LABEL_STRINGS[day];
		};
		const getMonthlyLabel = () => {
			const week = getFirstWeekWithDays(props.timingMonthly);
			if (!week) {
				return '';
			}
			const day = Array.from(props.timingMonthly[week].values())[0];
			if (!day) {
				return '';
			}
			return MONTHLY_LABEL_STRINGS[week][day];
		};
		return {
			DigestScheduleType,
			scheduleType,
			getWeeklyLabel,
			getMonthlyLabel,
		};
	},
});
